<template>
  <v-card class="mx-auto" max-width="200" outlined color="blue darken-1">
    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-title class="headline text-center">{{name}}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-card-actions>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <router-link :to="{name: 'List Categories', params: { appId: id }}">
            <v-icon color="black" dark v-bind="attrs" v-on="on">mdi-dns</v-icon>
          </router-link>
        </template>
        <span>Categories</span>
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <router-link :to="{name: 'List Laws', params: { appId: id }}">
            <v-icon color="black" dark v-bind="attrs" v-on="on">mdi-bank</v-icon>
          </router-link>
        </template>
        <span>Laws</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <router-link :to="{name: 'Edit App', params: { appId: id }}">
            <v-icon color="black" dark v-bind="attrs" v-on="on">mdi-pencil</v-icon>
          </router-link>
        </template>
        <span>Edit</span>
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon color="black" dark
            v-bind="attrs" v-on="on" @click="deleteItem">mdi-delete</v-icon>
        </template>
        <span>Delete</span>
      </v-tooltip>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'app-component',
  props: {
    id: Number,
    name: String,
  },
  data() {
    return {};
  },

  created() {},

  computed: {},

  methods: {
    deleteItem() {
      // eslint-disable-next-line no-alert
      if (window.confirm('Are you sure?')) {
        this.$store.dispatch('app/delete', this.id);
      }
    },
  },
};
</script>

<style scoped>
.v-list-item__title a {
  text-decoration: none;
  color: white;
}

.v-card__actions button a {
  color: inherit;
}
</style>
